// src/services/chromatogramService
import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetChromatogramByProjectRequest, GetChromatogramByProjectResponse, PatchChromatogramUpdateResponse, PostChromatogramResponse } from './types/TChromatogramServices';

const URL_Prefix = '/chromatogram';

export const chromatogramService = createApi({
    reducerPath: 'chromatogramService',
    baseQuery: getBaseQuery,
    tagTypes: ['Chromatogram'],
    endpoints: (builder) => ({
        updateChromatogram: builder.mutation<PatchChromatogramUpdateResponse, FormData>({
            query: (formData) => {
                const uuid = formData.get('uuid');
                return {
                    url: `${URL_Prefix}/${uuid}/update/`,
                    method: 'PATCH',
                    body: formData,
                    // Для FormData не устанавливаем Content-Type, браузер сделает это автоматически
                    headers: {
                        // Явно не устанавливаем Content-Type, чтобы браузер установил multipart/form-data с boundary
                    }
                };
            },
            invalidatesTags: ['Chromatogram'],
        }),
        getChromatogramByProject: builder.query<GetChromatogramByProjectResponse, GetChromatogramByProjectRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/by-project/${body.project_uuid}/`,
                method: 'GET',
            }),
        }),
        postChromatogram: builder.mutation<PostChromatogramResponse, FormData>({
            query: (formData) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: formData,
                // Для FormData не устанавливаем Content-Type, браузер сделает это автоматически
                headers: {
                    // Явно не устанавливаем Content-Type, чтобы браузер установил multipart/form-data с boundary
                }
            }),
            invalidatesTags: ['Chromatogram'],
        }),
    }),
});

export const {
    useGetChromatogramByProjectQuery,
    useLazyGetChromatogramByProjectQuery,
    useUpdateChromatogramMutation,
    usePostChromatogramMutation,
} = chromatogramService;